/*
 * @Description:
 * @Author: dingxuejin
 * @Date: 2021-02-17 14:03:09
 * @LastEditTime: 2021-02-17 14:03:44
 * @LastEditors: dingxuejin
 */
import { lazy } from "react";
const IndexLayout = lazy(() => import("@/components/layout/indexLayout"));
const Home = lazy(() => import("@/pages/home"));

export default {
    path: "/",
    description: "首  页",
    component: Home,
    layout: IndexLayout,
    title: "东经科技_包装产业数智化赋能平台_浙江东经科技股份有限公司",
    desc: "浙江东经科技股份有限公司成立于1994年，是一家深耕纸包装行业30余年的国家级高新技术企业。依托互联网、数字化、人工智能等前沿技术，东经科技从传统包装制造企业，成功转型为国内纸包装产业领先的产业互联网平台。目前，业务已覆盖全国22省299市，服务近5万家企业级用户，平台数据总量超11200亿条，五年实现交易额增长近10倍，成为推动中国纸包装产业数字化、智能化升级的核心力量。",
    keyword: "东经科技,浙江东经科技股份有限公司，包装产业数智化赋能平台，纸包装产业互联网平台，纸箱厂，纸板厂，您成功我发展，降本提效，价值倍增，让包装更有价值，营销管理赋能，AI综合智能体,ERP系统"
}
